module.exports = __webpack_public_path__ + "img/consultant_img.52228468.jpg";